import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

const DoughnutChart = ({labels, values, label}) => {

    const data = {
        labels,
        datasets: [
            {
                label,
                data: values,
                backgroundColor: [
                        'rgba(140, 46, 88, 1)',
                        'rgba(140, 46, 88, .5)',
                        'rgba(140, 46, 88, .25)',
                        'rgba(140, 46, 88, .12)',
                ],
                borderColor: [
                        'rgba(255, 255, 255, 1)',
                ],
                borderWidth: 4,
            },
        ],
    };

    return (
        <Doughnut data={data}  type="doughnut" />
    );
}

export default DoughnutChart;
